<template>
  <button
    type="button"
    @click="toggle"
    :aria-label="isDark ? t('theme.switchToLight') : t('theme.switchToDark')"
    :title="isDark ? t('theme.switchToLight') : t('theme.switchToDark')"
    :class="compact
      ? 'group flex flex-col items-center justify-center gap-1 w-[68px] py-2 rounded-md transition-colors text-muted-foreground hover:text-foreground hover:bg-accent'
      : 'flex items-center justify-center w-8 h-8 rounded-md border border-border bg-card text-muted-foreground shadow-ink-sm hover:text-foreground hover:bg-accent transition-colors'"
  >
    <Sun v-if="isDark" :class="compact ? 'w-5 h-5' : 'w-4 h-4'" :stroke-width="1.7" />
    <Moon v-else :class="compact ? 'w-5 h-5' : 'w-4 h-4'" :stroke-width="1.7" />
    <span v-if="compact" class="text-[10px] leading-none font-medium">{{ isDark ? t("theme.light") : t("theme.dark") }}</span>
  </button>
</template>

<script setup lang="ts">
import { Moon, Sun } from "lucide-vue-next";
import { useI18n } from "vue-i18n";
import { useTheme } from "../composables/useTheme";

defineProps<{ compact?: boolean }>();
const { t } = useI18n();
const { isDark, toggle } = useTheme();
</script>
